/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect } from "react";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

export default function RadarChart({ className, style, data }) {
  useEffect(() => {
    let chart = am4core.create("RadarChart", am4charts.RadarChart);
    // Add data
    chart.data = data;

    // Make chart not full circle
    chart.startAngle = -90;
    chart.endAngle = 180;
    chart.innerRadius = am4core.percent(60);
    chart.radius = am4core.percent(80);
    chart.logo.disabled = true;

    // Set number format
    chart.numberFormatter.numberFormat = "#.#'%'";

    // Create axes
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.fontWeight = 500;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.labels.template.adapter.add(
      "fill",
      function (fill, target) {
        return target.dataItem.index >= 0
          ? chart.colors.getIndex(target.dataItem.index)
          : fill;
      }
    );
    categoryAxis.renderer.minGridDistance = 10;

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.fontSize = 14;

    // Create series
    let series1 = chart.series.push(new am4charts.RadarColumnSeries());
    series1.dataFields.valueX = "full";
    series1.dataFields.categoryY = "category";
    series1.clustered = false;
    series1.columns.template.fill = new am4core.InterfaceColorSet().getFor(
      "alternativeBackground"
    );
    series1.columns.template.column.fill = "#6d7394";
    series1.columns.template.fillOpacity = 0.08;
    series1.columns.template.cornerRadiusTopLeft = 20;
    series1.columns.template.strokeWidth = 0;
    series1.columns.template.radarColumn.cornerRadius = 20;
    series1.stroke = am4core.color("#fff");

    let series2 = chart.series.push(new am4charts.RadarColumnSeries());
    series2.dataFields.valueX = "value";
    series2.dataFields.categoryY = "category";
    series2.clustered = false;
    series2.columns.template.strokeWidth = 0;
    series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
    series2.columns.template.radarColumn.cornerRadius = 20;

    // const colors = ["#FE7B2C", "#810B7D", "#03002F"];
    const colors2 = ["#0469DC", "#59C3C3", "#F45B69"];

    // Define an array of colors
    const fillColors = colors2;
    series2.columns.template.adapter.add("fill", (fill, target) => {
      if (target.dataItem && target.dataItem.dataContext) {
        return fillColors[target.dataItem.index];
      }
      return fill;
    });

    series1.columns.template.adapter.add("margin", (stroke, target) => {
      // Customize the stroke color based on your conditions
      if (target.dataItem && target.dataItem.dataContext) {
        return 10; // Change this to your desired stroke color
      }
      return stroke;
    });

    const labelColors = colors2;
    categoryAxis.renderer.labels.template.adapter.add(
      "fill",
      (fill, target) => {
        if (target.dataItem) {
          let index = target.dataItem.index;
          if (index >= 0 && index < labelColors.length) {
            return am4core.color(labelColors[index]);
          }
        }
        return fill;
      }
    );
    categoryAxis.renderer.labels.template.fontFamily = "Encode Sans";
    valueAxis.renderer.labels.template.fill = am4core.color("#7E8899");
    valueAxis.renderer.labels.template.fontFamily = "Roboto";

    // Add cursor
    chart.cursor = new am4charts.RadarCursor();
  }, [data]);

  return (
    <div
      id="RadarChart"
      className={className}
      // style={{ width: 450, height: 400, ...style }}
    />
  );
}
